import { FormGroup } from "../../components/form";
import * as Yup from "yup";

export const userForm: FormGroup = {
  type: "formGroup",
  fields: [
    {
      type: "field",
      key: "userEmail",
      fieldType: "input",
      label: "Email",
      validation: Yup.string()
        .trim()
        .required("Email is required")
        .matches(/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i, "Invalid email address"),
      expressionProps: {
        disabled: (context, values) => {
          return values.dateCreated != null;
        },
      },
    },
    {
      type: "field",
      key: "displayName",
      fieldType: "input",
      label: "Display name",
      validation: Yup.string().trim().required("Display name is required"),
    },
    {
      type: "field",
      key: "roleType",
      fieldType: "dropdown",
      label: "Role",
      validation: Yup.number().required("Role is required"),
      props: {
        options: [
          {
            label: "Root",
            value: 1,
          },
          {
            label: "Assessor",
            value: 2,
          },
          {
            label: "Manager",
            value: 3,
          },
          {
            label: "Provider",
            value: 4,
          },
          {
            label: "Kindergarten",
            value: 5,
          },
        ],
      },
    },
    {
      type: "field",
      key: "inviteRedirectUrl",
      fieldType: "value",
      defaultValue: import.meta.env.VITE_POSTLOGOUTREDIRECTURI,
      label: "Display name",
    },
  ],
};
